<!-- 页面已废弃 -->
<template>
  <div class="transmission-oil-recommend">
    <!-- 车型标题 -->
    <div class="model" @click="goHome">
      {{
        current.brand_name
          ? `${current.brand_name} - ${current.factory_name}`
          : this.$route.query.brand_name
          ? `${this.$route.query.brand_name} - ${this.$route.query.factory_name}`
          : "--"
      }}<i
        style="margin-left: 6px; color: #333"
        class="iconfont icon-arrowR font-10"
      />
    </div>
    <!-- Banner列表 -->
    <!-- <banner></banner> -->
    <!-- 油品信息 -->
    <div class="intro" v-if="JSON.stringify(maintainInfo) != '{}'">
      <div class="title">变速箱油</div>
      <div class="product-imgs">
        <div
          v-if="oilsInfo[0]"
          @click="preview(oilsInfo[0].imageUrls)"
          class="item"
        >
          <img :src="this.oilsInfo[0].imageUrls[0]" alt="变速箱油图片" />
          <span>{{ this.oilsInfo[0].nickName }}</span>
          <div class="price-box" v-if="oilsInfo[0].sell_price > 0">
            <span class="unit">￥</span>
            <span class="price-text">{{ oilsInfo[0].sell_price / 100 }}/L</span>
          </div>
        </div>
        <div
          v-if="oilsInfo[1]"
          @click="preview(oilsInfo[1].imageUrls)"
          class="item"
        >
          <img :src="this.oilsInfo[1].imageUrls[0]" alt="" />
          <span>{{ this.oilsInfo[1].nickName }}</span>
          <div class="price-box" v-if="oilsInfo[1].sell_price > 0">
            <span class="unit">￥</span>
            <span class="price-text">{{ oilsInfo[1].sell_price / 100 }}/L</span>
          </div>
        </div>
        <div class="empty" v-if="oilsInfo.length === 0">
          <img class="empty-img" src="@/assets/maintenance/empty-bg.png" />
          <span>暂无产品推荐～</span>
        </div>
      </div>
    </div>
    <!-- 养护信息 -->
    <div class="detail" v-if="JSON.stringify(maintainInfo) != '{}'">
      <div class="sub-title">养护信息</div>
      <div class="list">
        <div
          class="top-item"
          v-if="maintainInfo.gbDescribe || maintainInfo.datumFileNumber"
        >
          <div class="left">
            <p class="top-item-title">变速箱类型</p>
            <p class="top-item-content">
              {{ maintainInfo.gbDescribe ? maintainInfo.gbDescribe : "--" }}
            </p>
          </div>
          <div class="right">
            <p class="top-item-title required">挡位</p>
            <p class="top-item-content">
              {{
                maintainInfo.datumFileNumber
                  ? maintainInfo.datumFileNumber
                  : "--"
              }}
            </p>
          </div>
        </div>
        <div class="item" v-if="maintainInfo.gbNo || maintainInfo.company">
          <div class="title">型号/厂家</div>
          <div class="content">
            {{
              `${maintainInfo.gbNo ? maintainInfo.gbNo : "--"} / ${
                maintainInfo.company ? maintainInfo.company : "--"
              }`
            }}
            <span v-if="imgList[3].length > 0"
              >（<span
                class="click-text"
                v-if="imgList[3].length > 0"
                @click="preview(imgList[3])"
                >铭牌图</span
              >）</span
            >
          </div>
          <!-- <div class="content">DL382/0CK/大众（名牌图）</div> -->
        </div>
        <div
          class="item"
          v-if="maintainInfo.manualOil || maintainInfo.machineOil"
        >
          <div class="title">换油量</div>
          <div class="content">
            <span>{{
              maintainInfo.manualOil ? `重力：${maintainInfo.manualOil}L` : "--"
            }}</span
            >&nbsp;&nbsp;
            <span>{{
              maintainInfo.machineOil
                ? `机器：${maintainInfo.machineOil} ${
                    !isNaN(Number(maintainInfo.machineOil)) ? "L" : ""
                  }`
                : "--"
            }}</span>
          </div>
        </div>
        <div class="item" v-if="maintainInfo.gearBoxOil">
          <div class="title">齿轮箱油</div>
          <div class="content">
            {{ maintainInfo.gearBoxOil ? `${maintainInfo.gearBoxOil}L` : "--" }}
          </div>
        </div>
        <div class="item" v-if="maintainInfo.electUnitOil">
          <div class="title">机电单元油</div>
          <div class="content">
            {{
              maintainInfo.electUnitOil ? `${maintainInfo.electUnitOil}L` : "--"
            }}
          </div>
        </div>
        <div class="item" v-if="maintainInfo.gearboxClutch">
          <div class="title">变速箱离合器油</div>
          <div class="content">
            {{
              maintainInfo.gearboxClutch
                ? `${maintainInfo.gearboxClutch}L`
                : "--"
            }}
          </div>
        </div>
        <div class="item" v-if="gearbox_adapter.length > 0">
          <div class="title">接头(A)</div>
          <div class="content">
            <span v-if="gearbox_adapter.length > 0">
              <span v-for="(item, index) in gearbox_adapter" :key="index">
                <span>{{ item.supplierCode }}</span>
                <span
                  >（<span
                    class="click-text"
                    v-if="item.imageUrls.length > 0"
                    @click="preview(item.imageUrls)"
                    >图</span
                  >）</span
                >
                <img v-show="false" :src="item.imageUrls[0]" alt="" />
              </span>
            </span>
          </div>
        </div>
        <div class="item" v-if="maintainInfo.accInstead">
          <div class="title">养护套装</div>
          <div class="content">
            {{ maintainInfo.accInstead ? `${maintainInfo.accInstead}` : "--" }}
            <span
              class="click-text"
              @click="dialogShow = true"
              v-if="maintainInfo.accInstead === '无法更换'"
              >详细</span
            >
          </div>
        </div>
        <div class="item" v-if="maintainInfo.advice">
          <div class="title">技师建议</div>
          <div class="content">
            {{ maintainInfo.advice ? maintainInfo.advice : "--" }}
          </div>
        </div>
      </div>
    </div>
    <!-- 备注说明 -->
    <div class="note" v-if="imgsList.length > 0">
      <div class="item">
        <div class="title">备注说明</div>
        <div class="content">详情可见备注说明</div>
      </div>
      <div class="imgs">
        <div
          class="imgbox imgbox1"
          v-if="imgList[0].length > 0"
          @click="preview(imgList[0])"
        >
          <div class="img-box">
            <img :src="imgList[0][0]" alt="" />
            <div class="count">
              <i class="iconfont icon-tupian font-13"></i
              ><span>{{ imgList[0].length }}</span>
            </div>
          </div>
          <span>检查口/加注口/放油口</span>
        </div>
        <div
          class="imgbox imgbox2"
          v-if="imgList[1].length > 0"
          @click="preview(imgList[1])"
        >
          <div class="img-box">
            <img :src="imgList[1][0]" alt="" />
            <div class="count">
              <i class="iconfont icon-tupian font-13"></i
              ><span>{{ imgList[1].length }}</span>
            </div>
          </div>
          <span>接头位置（A）</span>
        </div>
        <div
          class="imgbox imgbox3"
          v-if="imgList[2].length > 0"
          @click="preview(imgList[2])"
        >
          <div class="img-box">
            <img :src="imgList[2][0]" alt="" />
            <div class="count">
              <i class="iconfont icon-tupian font-13"></i
              ><span>{{ imgList[2].length }}</span>
            </div>
          </div>
          <span>原厂换油</span>
        </div>
      </div>
    </div>
    <!-- 联系客服 -->
    <div
      v-if="
        loaded &&
        !(JSON.stringify(maintainInfo) === '{}' && oilsInfo.length === 0)
      "
      class="contact-us"
    >
      <div class="sub-title">联系客服</div>
      <div class="contact-us-content">
        <a class="phone-icon" href="tel:4006879616"></a>
        <a class="phone-btn" href="tel:4006879616">电话客服</a>
        <span>客服时间：9:00-17:00</span>
      </div>
    </div>
    <!-- 常见问题 -->
    <div
      v-if="
        loaded &&
        !(JSON.stringify(maintainInfo) === '{}' && oilsInfo.length === 0)
      "
      class="QA"
    >
      <div class="sub-title">常见问题</div>
      <Collapse :list="QAList" />
    </div>
    <!-- 页面空状态 -->
    <div
      class="all-empty"
      v-if="JSON.stringify(maintainInfo) === '{}' && oilsInfo.length === 0"
    >
      <div class="empty-box">
        <img
          src="@/assets/maintenance/empty-bg.png"
          class="empty-img"
          alt="empty"
        />
        <span>暂无数据～</span>
      </div>
    </div>
    <!-- 预加载图片 -->
    <div class="cacheImgs" v-if="imgsList.length > 0" v-show="false">
      <img v-for="(item, index) in imgsList" :key="index" :src="item" alt="" />
    </div>
    <!-- dialog -->
    <div class="dialog" @touchmove.prevent v-if="dialogShow">
      <div class="dialog-box">
        <div class="title">提示</div>
        <div class="content">
          由于变速箱结构问题，该车滤网为内置，常规保养无法拆卸更换，只有大修拆解变速箱方可进行更换。如果是干式双离合的变速箱则没有滤网。
        </div>
        <div class="btns" @click="dialogShow = false">我知道了</div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/apis/maintenance-api.js";
import { transmissionScene } from "@/store/scenes";
import { QAList } from "@/store/constants";
import { setStatistics } from "@/utils/common";
import Collapse from "@/components/Collapse";
import { userQueryCarModelRecord } from "@/utils/data-burial";
import validToken from "@/mixins/valid-token.js";
// import Banner from "@/views/maintenance/components/Banner.vue";
export default {
  name: "transmission-oil-recommend",
  components: {
    Collapse,
  },
  // components: {
  //   Collapse,
  //   Banner,
  // },
  mixins: [validToken],
  data() {
    return {
      dialogShow: false,
      current: {},
      oilsInfo: {},
      maintainInfo: {},
      imgList: [[], [], [], []],
      gearbox_adapter: [], //养护信息-接头
      QAList: QAList,
      loaded: false,
      vehicle_id: "",
    };
  },
  computed: {
    imgsList() {
      // return [];
      return this.imgList ? this.imgList.flat() : [];
    },
  },
  async mounted() {
    // console.log(this.imgsList);
    this.current = sessionStorage.getItem("current")
      ? JSON.parse(sessionStorage.getItem("current"))
      : {};
    await this.fetchDetail();
    await this.queryDataRecord();
    this.loaded = true;
  },
  methods: {
    goHome() {
      this.$router.push({
        path: "/home",
        query: {
          id: this.$route.query.scheme_id,
        },
      });
    },
    // idx- 当前图片组具体图片索引
    preview(imgsArr, idx = 0) {
      this.$imagePreview({
        images: imgsArr,
        index: idx,
        defaultOpt: {
          fullscreenEl: false,
          arrowEl: true,
          preloaderEl: true,
          bgOpacity: 0.85,
          preload: [1, 1],
          showHideOpacity: true,
          showAnimationDuration: 0,
        },
      });
    },
    async fetchDetail() {
      await this.fetchValidToken();
      if (!this.token) return;
      this.$loading.show("加载中...");
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const params = {
        displacement:
          this.current.displacement || this.$route.query.displacement,
        brand_name: this.current.brand_name || this.$route.query.brand_name,
        model_alias: this.current.model_alias || this.$route.query.model_alias,
        sales_name: this.current.sales_name || this.$route.query.sales_name,
        release_year:
          this.current.release_year || this.$route.query.release_year,
        factory_name:
          this.current.factory_name || this.$route.query.factory_name,
        parts_type: 2,
        vehicle_ids: this.$route.query.id ? [this.$route.query.id] : [],
        token: this.token,
        scheme_id,
      };
      try {
        const res = await api.getModelDetail(params);
        if (
          res.code !== 0 &&
          (res.code === 40800 ||
            res.code === 40700 ||
            res.code === 40900 ||
            res.code === 40910)
        ) {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
          return;
        }
        this.vehicle_id =
          res.data.vehicle_list && res.data.vehicle_list[0]
            ? res.data.vehicle_list[0].id
            : this.$route.query.id
            ? this.$route.query.id
            : "";
        // console.log(res.data);
        // 设置油品信息
        // console.log(this.$route.query.key);
        if (this.$route.query.key === "default" || !this.$route.query.key) {
          this.oilsInfo = res.data.parts_list[0]
            ? res.data.parts_list[0].part_detail
            : [];
          this.gearbox_adapter = res.data.parts_list[0]
            ? res.data.parts_list[0].gearbox_adapter
            : []; //养护-接头信息
        } else {
          let curInfo = res.data.parts_list.find(
            (i) => i.key == this.$route.query.key
          );
          // console.log(111, curInfo);
          this.oilsInfo = curInfo.part_detail;
          this.gearbox_adapter = curInfo.gearbox_adapter; //养护-接头信息
        }
        // 设置养护信息
        if (this.$route.query.key == "default" || !this.$route.query.key) {
          if (res.data.datum_list.length > 0) {
            let maintainTemp = res.data.datum_list[0].datum_detail.datumAttrs;
            this.maintainInfo = maintainTemp.reduce((res, cur) => {
              res[`${cur.attrKey}`] = cur.attrValue;
              return res;
            }, {});
            this.maintainInfo.datumImages =
              res.data.datum_list[0].datum_detail.datumImages;
          }
        } else {
          let maintainTemp = res.data.datum_list.find(
            (i) => i.key === this.$route.query.key
          );
          // console.log(111, maintainTemp);
          this.maintainInfo = maintainTemp.datum_detail.datumAttrs;
          this.maintainInfo = this.maintainInfo.reduce((res, cur) => {
            res[`${cur.attrKey}`] = cur.attrValue;
            return res;
          }, {});
          this.maintainInfo.datumImages = maintainTemp.datum_detail.datumImages;
        }
        this.sortImgs();
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
      // console.log("this.oilsInfo", this.oilsInfo);
      // console.log("this.maintainInfo", this.maintainInfo);
    },
    // 整理收集图片组
    sortImgs() {
      if (this.maintainInfo.datumImages.length > 0) {
        let tempImgsArr = this.maintainInfo.datumImages;
        let temp1 = tempImgsArr
          .filter(
            (i) =>
              i.resName === "检查口" ||
              i.resName === "加注口" ||
              i.resName === "放油口"
          )
          .map((i) => i.resUrl);
        let temp2 = tempImgsArr
          .filter((i) => i.resName === "接头位置(A)")
          .map((i) => i.resUrl);
        let temp3 = tempImgsArr
          .filter((i) => i.resName === "原厂换油")
          .map((i) => i.resUrl);
        let temp4 = tempImgsArr
          .filter((i) => i.resName === "铭牌图")
          .map((i) => i.resUrl);
        temp1.length == 0 ? (temp1 = []) : "";
        temp2.length == 0 ? (temp2 = []) : "";
        temp3.length == 0 ? (temp3 = []) : "";
        temp4.length == 0 ? (temp4 = []) : "";
        this.imgList = [temp1, temp2, temp3, temp4];
        // console.log(111, this.imgList);
      }
    },
    // 查询数据记录
    async queryDataRecord() {
      if (!window.localStorage.getItem("OILUSER")) {
        await setStatistics.apply(this, []);
      }
      const uuid = window.localStorage.getItem("OILUSER")
        ? Number(window.localStorage.getItem("OILUSER"))
        : "";
      const { internal_from } = this.$route.query;
      const {
        brand_name,
        model_alias,
        factory_name,
        sales_name,
        displacement,
      } = this.$route.query;
      const basic_info = {
        choose_vehicle_id: this.vehicle_id,
        menu_type: 2,
        uuid: uuid,
        scheme_id: this.$route.query.scheme_id,
        search_type:
          internal_from === "photo_vin"
            ? 2
            : internal_from === "text_vin"
            ? 3
            : 1,
        brand_name,
        model_alias,
        displacement,
        factory_name,
        sales_name,
      };
      await userQueryCarModelRecord.apply(this, [basic_info]);
    },
  },

  beforeRouteLeave(to, from, next) {
    if (transmissionScene.includes(to.name)) {
      next();
    } else {
      sessionStorage.removeItem("current");
      next();
    }
  },
};
</script>
<style lang="less" scoped>
.click-text {
  color: #2379ce;
  text-decoration: underline;
}
.transmission-oil-recommend {
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  .model {
    font-size: 27/100rem;
    color: #404040;
    margin: 34/100rem 0 0 0;
    padding-left: 17/100rem;
  }
  .intro {
    width: 100%;
    // height: 401/100rem;
    background-color: #fff;
    margin-bottom: 26/100rem;
    display: flex;
    flex-direction: column;
    margin-top: 34/100rem;
    .title {
      font-size: 27/100rem;
      padding-left: 17/100rem;
      font-weight: 600;
      color: #404040;
      margin: 26/100rem 0 34/100rem 0;
    }
    .product-imgs {
      display: flex;
      justify-content: space-between;
      // align-items: center;
      padding: 0 32/100rem;
      .price-box {
        margin-top: 14/100rem;
        margin-bottom: 26/100rem;
        .unit {
          font-weight: 500;
          color: #ce4747;
          font-size: 24/100rem;
        }
        .price-text {
          font-weight: 500;
          color: #ce4747;
          line-height: 43/100rem;
          font-size: 31/100rem;
        }
      }
      .item {
        display: flex;
        flex-direction: column;
        text-align: center;
        font-size: 24/100rem;
        width: 258/100rem;
        color: #404040;
        align-items: center;
        justify-content: flex-start;
        img {
          width: 184/100rem;
          height: 184/100rem;
          background-color: #eee;
          margin-bottom: 26/100rem;
          box-shadow: 0 3/100rem 20/100rem 0 rgba(0, 0, 0, 0.05);
          border-radius: 9/100rem;
        }
      }
      .empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        margin-top: 32/100rem;
        .empty-img {
          width: 157/100rem;
          height: 157/100rem;
        }
        span {
          margin: 12/100rem;
          color: #7f7f7f;
          font: 27/100rem;
        }
      }
    }
  }
  .detail {
    background-color: #fff;
    padding: 0 17/100rem;
    display: flex;
    flex-direction: column;
    padding-bottom: 30/100rem;
    .sub-title {
      font-weight: 600;
      color: #404040;
      font-size: 27/100rem;
      margin: 26/100rem 0 17/100rem 0;
    }
    .list {
      .title {
        font-size: 24/100rem;
        font-weight: 400;
        color: #404040;
        white-space: nowrap;
        margin-right: 20/100rem;
      }
      .top-item {
        height: 154/100rem;
        background: #fafafa;
        border-radius: 20/100rem;
        padding: 29/100rem 0 27/100rem 0;
        display: flex;
        justify-content: space-between;
        margin-bottom: 18/100rem;
        .left {
          border-right: 2px solid #dedede;
        }
        .left,
        .right {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .top-item-title {
            color: #999999;
            font-size: 24/100rem;
            margin-bottom: 10/100rem;
          }
          .top-item-content {
            line-height: 48/100rem;
            color: #000000;
            font-size: 34/100rem;
          }
        }
      }
      .item {
        display: flex;
        justify-content: space-between;
        min-height: 85/100rem;
        line-height: 85/100rem;
        border-bottom: 1px solid #f0f0f0;
        .content {
          margin-top: 22/100rem;
          margin-bottom: 10/100rem;
          color: #a1a1a1;
          font-size: 24/100rem;
          line-height: 40/100rem;
        }
      }
    }
  }
  .note {
    background-color: #fff;
    margin-top: 26/100rem;
    padding: 0 17/100rem;
    .item {
      display: flex;
      justify-content: space-between;
      margin: 26/100rem 0 26/100rem 0;
      font-size: 24/100rem;
      .title {
        color: #404040;
      }
      .content {
        color: #a1a1a1;
      }
    }
    .imgs {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 46/100rem;
      .imgbox:first-child {
        margin-left: 0;
      }
      .imgbox {
        width: 188/100rem;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #404040;
        text-align: center;
        margin-left: 20/100rem;
        font-size: 20/100rem;
        .img-box {
          width: 100%;
          height: 188/100rem;
          border-radius: 9/100rem;
          overflow: hidden;
          border: 1px #f3f2f2 solid;
          margin-bottom: 17/100rem;
          position: relative;
          box-shadow: 0 3/100rem 20/100rem 0 rgba(0, 0, 0, 0.05);
          img {
            width: 100%;
            height: 188/100rem;
          }
          .count {
            background: rgba(0, 0, 0, 0.5);
            height: 31/100rem;
            padding: 2/100rem 9/100rem;
            color: #fff;
            font-size: 17/100rem;
            border-radius: 15/100rem;
            position: absolute;
            right: 9/100rem;
            bottom: 9/100rem;
            display: flex;
            align-items: center;
            i {
              margin-right: 2/100rem;
              font-size: 17/100rem;
              font-weight: 200;
            }
          }
        }
      }
    }
  }
  // 联系客服
  .contact-us {
    width: 100%;
    height: 389/100rem;
    padding: 26/100rem 17/100rem;
    background-color: #fff;
    margin-top: 26/100rem;
    margin-bottom: 26/100rem;
    display: flex;
    flex-direction: column;
    .sub-title {
      font-weight: 600;
      color: #404040;
      font-size: 27/100rem;
      margin-bottom: 32/100rem;
    }
    .contact-us-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .phone-icon {
        width: 114/100rem;
        height: 114/100rem;
        margin-bottom: 24/100rem;
        background: url(../../assets/maintenance/Landline-phone-icon.png)
          no-repeat center center;
        background-size: cover;
      }
      .phone-btn {
        display: inline-block;
        width: 295/100rem;
        height: 61/100rem;
        background: #fbce07;
        border-radius: 31/100rem;
        color: #ffffff;
        text-align: center;
        line-height: 61/100rem;
      }
      span {
        margin-top: 17/100rem;
        color: #a1a1a1;
        font-size: 24/100rem;
      }
    }
  }
  // 常见问题
  .QA {
    width: 100%;
    height: auto;
    padding: 26/100rem 17/100rem;
    background-color: #fff;
    margin-bottom: 60/100rem;
    display: flex;
    flex-direction: column;
    .sub-title {
      font-weight: 600;
      color: #404040;
      font-size: 27/100rem;
      margin-bottom: 26/100rem;
    }
  }
  .view-box {
    width: 100%;
    position: absolute;
  }
}
.all-empty {
  height: 90vh;
  display: flex;
  justify-content: center;
  .empty-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    .empty-img {
      margin-top: 208/100rem;
      width: 191/100rem;
      height: 191/100rem;
    }
    span {
      margin-top: 26/100rem;
      font-size: 27/100rem;
      color: #7f7f7f;
    }
  }
}
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background: rgba(00, 00, 00, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  animation: dialog-fadein 0.4s;
  .dialog-box {
    width: 80%;
    height: auto;
    background: #fff;
    margin: 0 auto;
    padding: 30/100rem;
    display: flex;
    flex-direction: column;
    animation: dialog-zoom 0.4s;
    border-radius: 20/100rem;
    .title {
      margin-bottom: 20/100rem;
    }
    .content {
      font-size: 24/100rem;
      color: #333;
      line-height: 40/100rem;
    }
    .btns {
      width: 100%;
      text-align: center;
      margin-top: 20/100rem;
      color: #7ba1e7;
      font-size: 26/100rem;
      margin-bottom: 10/100rem;
    }
  }
}
@keyframes dialog-fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes dialog-zoom {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.required::before {
  content: "* ";
  color: #d51317;
}
</style>
